import ApiClient from "../client";
import { PaginatedResponse } from "../types";
import {
  ApiTask,
  ApiTaskCreatePayload,
  ApiTaskUpdatePayload,
  ApiTaskSet,
  ApiTaskSetDetail,
  ApiTaskSetCreatePayload,
  ApiTaskSetUpdatePayload,
} from "../types/tasks";

type GetTaskSetOpts = {
  since?: string;
  until?: string;
};

export const getTaskSets = (
  client: ApiClient,
  venueUuid: string,
  opts?: GetTaskSetOpts
) => {
  return client.get<PaginatedResponse<ApiTaskSet>>(
    `/venues/${venueUuid}/tasksets`,
    {
      searchParams: opts,
    }
  );
};

export const getTaskSet = (client: ApiClient, uuid: string) => {
  return client.get<ApiTaskSetDetail>(`/tasksets/${uuid}`);
};

export const getTaskSetForCompetition = (
  client: ApiClient,
  competitionUuid: string
) => {
  return client.get<ApiTaskSetDetail>(
    `/tasksets/for-competition/${competitionUuid}`
  );
};

export const createTaskSet = (
  client: ApiClient,
  payload: ApiTaskSetCreatePayload
) => {
  return client.post<ApiTaskSet>(`/tasksets`, payload);
};

export const updateTaskSet = (
  client: ApiClient,
  uuid: string,
  payload: ApiTaskSetUpdatePayload
) => {
  return client.patch<ApiTaskSet>(`/tasksets/${uuid}`, payload);
};

export const deleteTaskSet = (client: ApiClient, uuid: string) => {
  return client.delete(`/tasksets/${uuid}`);
};

export const announceTaskSet = (client: ApiClient, uuid: string) => {
  return client.post(`/tasksets/${uuid}/announce`);
};

export const getTask = (client: ApiClient, uuid: string) => {
  return client.get<ApiTask>(`/tasks/${uuid}`);
};

export const updateTask = (
  client: ApiClient,
  uuid: string,
  payload: ApiTaskUpdatePayload
) => {
  return client.patch<ApiTask>(`/tasks/${uuid}`, payload);
};

export const createTask = (
  client: ApiClient,
  payload: ApiTaskCreatePayload
) => {
  return client.post<ApiTask>("/tasks", payload);
};

export const deleteTask = (client: ApiClient, uuid: string) => {
  return client.delete(`/tasks/${uuid}`);
};

export const endpoints = {
  getTasksets: getTaskSets,
  getTaskset: getTaskSet,
  getTaskSetForCompetition,
  createTaskSet,
  updateTaskSet,
  deleteTaskSet,
  announceTaskSet,
  getTask,
  updateTask,
  createTask,
  deleteTask,
};
